import { render, staticRenderFns } from "./activityRegisterDet.vue?vue&type=template&id=0b669e66&scoped=true"
import script from "./activityRegisterDet.vue?vue&type=script&lang=js"
export * from "./activityRegisterDet.vue?vue&type=script&lang=js"
import style0 from "./activityRegisterDet.vue?vue&type=style&index=0&id=0b669e66&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b669e66",
  null
  
)

export default component.exports